<template>
  <div class="charts-page">
    <div class="row topCardGrid">
        <sp-card :valor="totais.unidades" :descricao="$t('graficosEducacao.cardUnidades')" :lgGrid="4" :footerText="$t('rodape.fonteData', {fonte: sigla, data: dataRef})"/>
        <sp-card :valor="totais.turmas" :descricao="$t('graficosEducacao.cardTurmas')" :lgGrid="4" :footerText="$t('rodape.fonteData', {fonte: sigla, data: dataRef})"/>
        <sp-card :valor="totais.transporte" sufix="viagens" :descricao="$t('graficosEducacao.cardViagens')" :lgGrid="4" :footerText="$t('rodape.fonteData', {fonte: sigla, data: dataRef})"/>
    </div>
    <div class="row">
        <div class="flex md12 xs12">
            <sp-360-panel class="chart-widget" :title="$t('graficosEducacao.redeEnsino')" :tooltipOptions="topToolTipOptions"
            :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">
                <div class="md12 xs12 chart" style="position: relative;">
                    <div class="row">
                        <div class="flex md6 xs12">
                            <multiselect
                                id="selectInstituicoes"
                                placeholder="Filtro por Instituição"
                                :value="selTipo"
                                :options="tipos"
                                :close-on-select="true"
                                :show-labels="false"
                                @input="updatetipo"

                            />
                        </div>
                        <div class="flex md6 xs12">
                            <multiselect
                                id="selectSubprefeituras"
                                name="Subprefeituras"
                                placeholder="Filtro por Subprefeitura"
                                :value="selSub"
                                :options="subs"
                                :close-on-select="true"
                                :show-labels="false"
                                @input="updatesub"
                            />
                        </div>
                    </div>
                    <GmapMap
                        id="mapaTransito"
                        ref="gmap"
                        :center="this.center"
                        :zoom="this.zoom"
                        map-type-id="roadmap"
                        style="width: 100%; height: 35rem">
                    </GmapMap>
                    <div id="legenda" class="legenda d-flex justify-content-center"/>
                </div>
            </sp-360-panel>
        </div>
    </div>
  </div>
</template>

<script>
import CorUtils from '@/utils/CorUtils'
import MethGlob from '@/utils/MetodosGlobais'
import constantes from '@/utils/ConstantesGlobais'
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels'
import Multiselect from 'vue-multiselect'
import _ from 'lodash'
import Overlay from '@/assets/geojson/spoverlay'
import SpCard from '@/components/ui/cards/SP360Card'
import { gmapApi } from 'vue2-google-maps'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import * as d3 from 'd3'
import Legenda from '@/components/maps/360-maps/Legenda'

export default {
  name: 'rede-ensino',
  mixins: [Overlay, Legenda],
  components: {
    SpCard,
    Multiselect,
    Sp360Panel,
  },

  data () {
    return {
      selTipo: '',
      selSub: '',
      tipos: [],
      subs: [],
      dados: {},
      totais: {},
      demandaCreche: [],
      heatMapData: [],
      tooltipOptions: {
        content: '',
        placement: 'top',
      },
      center: constantes.PARAMETROS_DASHBOARD.MOBILIDADE.GMAP_CENTER,
      zoom: constantes.PARAMETROS_DASHBOARD.MOBILIDADE.GMAP_ZOOM,
      topToolTipOptions: {
        content: this.$t('graficosEducacao.redeEnsinoTooltip'),
        placement: 'bottom',
      },
      heatmap: {},
      filtrado: false,
    }
  },

  computed: {
    google: gmapApi,
  },

  created () {
    this.$store.dispatch('servicosSME/buscarRedeEnsino', { agrupamento: 'NENHUM' })
      .then((resposta) => {
        this.processarDados(resposta.data)
        this.iniciaGmap(this.heatMapData)
        this.sigla = resposta.sigla_orgao
        this.fonte = resposta.sigla_orgao + '-' + resposta.fonte
        this.dataRef = new Date(resposta.data_referencia_dado).toLocaleDateString('pt-BR')
        this.ref = this.$t('rodape.fonteData', { fonte: this.fonte, data: this.dataRef })
      })
  },

  mounted () {

  },

  methods: {
    rodapeData (d, data) {
      return MethGlob.rodapeData(d, data)
    },

    updatetipo (value) {
      this.selTipo = value
      this.reload()
    },

    updatesub (value) {
      this.selSub = value
      this.reload()
    },

    formatarNumero (x) {
      return MethGlob.thousandSeparator(x)
    },

    /**
     *
     * @dados : {Array}
     */
    processarDados (dados) {
      this.totais = {
        turmas: 0,
        unidades: 0,
        transporte: 0,
        demandaCreche: 0,
      }

      this.$gmapApiPromiseLazy().then(() => { // Aguarda a API Assincrona do Gmaps carregar para executar o codigo abaixo.
        dados.forEach(element => {
          this.totais.transporte += element.alunos_transporte_gratuito
          this.totais.turmas += element.numero_turmas
          this.totais.demandaCreche += element.demanda_creche

          this.heatMapData.push({
            location: new google.maps.LatLng(element.posicao.lat, element.posicao.lng),
            weight: element.total_matriculas,
            sub: element.nome_subprefeitura,
            tipo: element.tipo,
          })
        })

        this.totais.unidades = dados.length
        this.dados = dados
      })
      this.tipos = _.orderBy(Object.keys(_.groupBy(dados, 'tipo')))
      this.subs = _.orderBy(Object.keys(_.groupBy(dados, 'nome_subprefeitura')))
    },

    proporcaoTurmaUnidade (dados) {
      dados.forEach(element => {
        element.posicao.weight = (element.numero_turmas / this.totais.turmas) * 100
      })
    },

    arranjo (dados, propriedade) {
      if (dados && propriedade) {
        this.arranjo = _.groupBy(dados, propriedade)
      }
    },

    iniciaGmap (heatMapData) {
      this.center = constantes.PARAMETROS_DASHBOARD.MOBILIDADE.GMAP_CENTER
      this.zoom = constantes.PARAMETROS_DASHBOARD.MOBILIDADE.GMAP_ZOOM_SME
      this.$refs.gmap.$mapPromise.then((map) => {
        let heatmap = new google.maps.visualization.HeatmapLayer({
          data: heatMapData,
        })
        heatmap.setMap(map)
        heatmap.setOptions({
          dissipating: true,
          // maxIntensity: 10,
          radius: 8,
          opacity: 1,
          gradient: CorUtils.getGradientVector(),
        })
        map.data.addGeoJson(this.getGeoJsonLayer())
        // Setando o estilo pro Polygon

        map.data.setStyle({
          /* fillColor: 'green', */
          strokeWeight: 0,
        })
        this.heatmap = heatmap
        heatMapData = _.orderBy(heatMapData, ['weight'], ['asc'])

        this.drawLegendaGradiente(d3.select('#legenda'), CorUtils.getGradientVector(), ['', '', '', '', '', ''], _.first(heatMapData).weight, _.last(heatMapData).weight, d3.select('#legenda')._groups[0][0].clientWidth, 50, this.$t('graficosEducacao.textoEixoLegenda.mapaEscolasNumeroMatriculas'))
      })
    },

    reload () {
      let filtrados = []
      if (this.selSub && this.selTipo) { // Filtrando pelos DOIS CAMPOS
        filtrados = _.filter(this.heatMapData, (o) => {
          return (o.sub === this.selSub && o.tipo === this.selTipo)
        })
      } else if (this.selSub || this.selTipo) { // Filtrando por UM DOS CAMPOS
        filtrados = _.filter(this.heatMapData, (o) => {
          return (o.sub === this.selSub || o.tipo === this.selTipo)
        })
      } else { // RESET do Filtro
        filtrados = this.heatMapData
      }
      this.heatmap.setData(filtrados)
    },
  },
}
</script>

<style lang="scss" scoped>

    .va-chart {
        height: 550px;
    }

    .wrapperMobPrinc {
        width: 40%;
        height: 40%;
        float: right;
        position: absolute;
    }

    .componente {
        margin-right: 10px;
    }

    .va-scrollbar {
        position: relative;
        height: 400px;

        .scrollbar-wrapper {
            box-shadow: none;
        }
    }

    .divTransparente {
        z-index: 10;
        position: absolute;
        top:0;
        left: 70%;
        height: 60%;
        width: 30%;
        background: rgba(0, 0, 0, 0.75);
        border-radius: 25px;
        min-height: 480px;
        max-height: 480px;
    }

    .divColapsada {
        z-index: 10;
        position: absolute;
        top:0;
        left: 70%;
        height: 7%;
        width: 30%;
        background: rgba(0, 0, 0, 0.75);
        border-radius: 25px;
        min-height: 60px;
    }

    .textDivInfo {
        color: white;
        margin: 10px 10px 10px 10px;
    }

    #tituloMob {
        text-align: center;
        text-decoration: underline;
        cursor: pointer;
        margin-bottom: 20px;
        margin-top: 20px;
    }

    .tituloProgress {
        margin-top: 10px;
    }

    @media (min-width: 1275px) and (max-width: 1500px) {
        .va-scrollbar {
            position: relative;
            height: 430px;

        }

        .divTransparente {
            z-index: 10;
            position: absolute;
            top:0;
            left: 70%;
            height: 100%;
            width: 30%;
            background: rgba(0, 0, 0, 0.75);
            border-radius: 25px;
        }

        .divColapsada {
            z-index: 10;
            position: absolute;
            top:0;
            left: 70%;
            height: 7%;
            width: 30%;
            background: rgba(0, 0, 0, 0.75);
            border-radius: 25px;
        }

        #tituloMob {
            text-align: center;
            text-decoration: underline;
            cursor: pointer;
            margin-bottom: 5px;
            margin-top: 5px;
        }

    }

    @media (max-width: 1274px) {
        .divTransparente {
            z-index: 10;
            position: relative;
            bottom:0;
            background: none;
            left: 0;
            height: 100%;
            width: 100%;
        }

        .divColapsada {
            text-align: center;
            z-index: 10;
            position: relative;
            background: none;
            top:0;
            left: 70%;
            height: 10px;
            width: 30%;
        }

        #tituloMob {
            text-align: center;
            text-decoration: underline;
            cursor: pointer;
            margin-bottom: 20px;
            margin-top: 5px;
        }

        .textDivInfo {
            color: black;
            margin: 10px 10px 10px 10px;
        }

        .tituloProgress {
            margin-top: 10px;
        }
    }
</style>
